"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = exports.DropdownContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.DropdownContext = react_1.createContext({ isOpen: false, toggle: () => { } });
const Dropdown = (_a) => {
    var { children, isOpen, toggle } = _a, props = __rest(_a, ["children", "isOpen", "toggle"]);
    const containerRef = react_1.useRef(null);
    const [internalOpen, setInternalOpen] = react_1.useState(false);
    const internalToggle = react_1.useCallback(() => setInternalOpen(old => !old), [setInternalOpen]);
    const contextValue = react_1.useMemo(() => isOpen === undefined || toggle === undefined
        ? { isOpen: internalOpen, toggle: internalToggle }
        : { isOpen, toggle }, [internalOpen, isOpen, toggle, internalToggle]);
    react_1.useEffect(() => {
        const dismissOnOutsideClick = (e) => {
            if (containerRef.current) {
                if (!containerRef.current.contains(e.target) && contextValue.isOpen) {
                    contextValue.toggle();
                }
            }
        };
        document.addEventListener('click', dismissOnOutsideClick);
        return () => {
            document.removeEventListener('click', dismissOnOutsideClick);
        };
    }, [contextValue]);
    return (jsx_runtime_1.jsx(exports.DropdownContext.Provider, Object.assign({ value: contextValue }, { children: jsx_runtime_1.jsx(Box_1.Box, Object.assign({ ref: containerRef, position: "relative", my: 1 }, props, { children: children }), void 0) }), void 0));
};
exports.Dropdown = Dropdown;
//# sourceMappingURL=index.js.map